module.exports = __webpack_public_path__ + "img/mood_doubt.4eedb8a5.png";